// The league a League Table / Match Results / Squad opens on, including a linked player change
// it was told to follow (`_followPlayer`, canvas/league-follow.ts). Worked out once, on mount
// (the three rebuild on every refresh); the flag is then cleared, so a later Undo checkpoint
// or Refresh doesn't follow again.

import { useEffect, useState } from "react";
import type { CompetitionId, LeagueChoice } from "../data/league.js";
import { getModState, setModState } from "../modules/bridge.js";
import { resolveFollowCompetition } from "../modules/league-table-view.js";
import { flashLinkSkipped } from "../canvas/league-follow.js";

export function useFollowedCompetition(
  mod: HTMLElement,
  /** The module's own `_`-state key for its league (e.g. "_leagueTableCompetition"). */
  stateKey: string,
  competitions: LeagueChoice[],
  stickyLeague: CompetitionId | null,
): { competition: CompetitionId | null; followed: boolean } {
  const [result] = useState(() =>
    resolveFollowCompetition(
      getModState<CompetitionId>(mod, stateKey),
      competitions,
      stickyLeague,
      getModState<boolean>(mod, "_followPlayer") === true,
    ),
  );
  useEffect(() => {
    if (getModState<boolean>(mod, "_followPlayer") !== true) return;
    setModState(mod, "_followPlayer", undefined);
    // The player's league isn't one this module can show: it stays put and says so.
    if (result.skipped) flashLinkSkipped(mod);
  }, [mod, result]);
  return result;
}
